import { render, staticRenderFns } from "./SupersessionManagerPage.vue?vue&type=template&id=71195055&scoped=true"
import script from "./SupersessionManagerPage.vue?vue&type=script&lang=js"
export * from "./SupersessionManagerPage.vue?vue&type=script&lang=js"
import style0 from "./SupersessionManagerPage.vue?vue&type=style&index=0&id=71195055&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71195055",
  null
  
)

export default component.exports